/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usually_Replies_InstantlyInputs */

const en_usually_replies_instantly = /** @type {(inputs: Usually_Replies_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usually replies instantly`)
};

const es_usually_replies_instantly = /** @type {(inputs: Usually_Replies_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalmente responde al instante`)
};

const fr_usually_replies_instantly = /** @type {(inputs: Usually_Replies_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répond généralement instantanément`)
};

const de_usually_replies_instantly = /** @type {(inputs: Usually_Replies_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwortet normalerweise sofort`)
};

const ja_usually_replies_instantly = /** @type {(inputs: Usually_Replies_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通常はすぐに返信します`)
};

const zh_usually_replies_instantly = /** @type {(inputs: Usually_Replies_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通常即时回复`)
};

const ar_usually_replies_instantly = /** @type {(inputs: Usually_Replies_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عادة ما يرد فوراً`)
};

const id_usually_replies_instantly = /** @type {(inputs: Usually_Replies_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biasanya membalas secara instan`)
};

const it_usually_replies_instantly = /** @type {(inputs: Usually_Replies_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risponde solitamente all'istante`)
};

const ru_usually_replies_instantly = /** @type {(inputs: Usually_Replies_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обычно отвечает мгновенно`)
};

const pt_usually_replies_instantly = /** @type {(inputs: Usually_Replies_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geralmente responde instantaneamente`)
};

const ko_usually_replies_instantly = /** @type {(inputs: Usually_Replies_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보통 즉시 답변합니다`)
};

/**
* | output |
* | --- |
* | "Usually replies instantly" |
*
* @param {Usually_Replies_InstantlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const usually_replies_instantly = /** @type {((inputs?: Usually_Replies_InstantlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usually_Replies_InstantlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_usually_replies_instantly(inputs)
	if (locale === "es") return es_usually_replies_instantly(inputs)
	if (locale === "fr") return fr_usually_replies_instantly(inputs)
	if (locale === "de") return de_usually_replies_instantly(inputs)
	if (locale === "ja") return ja_usually_replies_instantly(inputs)
	if (locale === "zh") return zh_usually_replies_instantly(inputs)
	if (locale === "ar") return ar_usually_replies_instantly(inputs)
	if (locale === "id") return id_usually_replies_instantly(inputs)
	if (locale === "it") return it_usually_replies_instantly(inputs)
	if (locale === "ru") return ru_usually_replies_instantly(inputs)
	if (locale === "pt") return pt_usually_replies_instantly(inputs)
	return ko_usually_replies_instantly(inputs)
});